import type { Currency } from '@ps/web-core-enums';
import type { AdditionalConfigBlock, MultiplierBlock, StakeBlock } from '@ps/web-martech-cms-types';
import type { DeepNonNullable } from 'utility-types';

import type {
  CashGamesGroupedUpdateSubscription,
  CommonSimpleGameFragment
} from '@swf/generated/graphql/poker/CG/operations';

export enum NavigationTabs {
  HOLDEM = 'HOLDEM',
  OMAHA = 'OMAHA'
}

export type NavigationTabTypes = keyof typeof NavigationTabs;

export interface NavigationTabUrl {
  holdem: 'holdem';
  omaha: 'omaha';
}

export type NavigationTabUrlKey = keyof NavigationTabUrl;

export type GamesUpdateData = NonNullable<
  DeepNonNullable<Omit<CashGamesGroupedUpdateSubscription, '__typename'>['cashGamesGrouped']>
>;

export enum GameType {
  HOLDEM = 'POKER_GAME_TYPE_HOLDEM',
  OMAHA = 'POKER_GAME_TYPE_OMAHA'
}

export enum TableType {
  REGULAR = 'POKER_TABLE_TYPE_REGULAR',
  ZOOM = 'POKER_TABLE_TYPE_FAST_FOLD'
}

export type SliderValues = Pick<
  CommonSimpleGameFragment,
  'minBuyIn' | 'maxBuyIn' | 'tableSize' | 'gameType' | 'currency' | 'tableType' | 'bettingLimit'
> &
  Pick<CommonSimpleGameFragment['blindStructure'], 'smallBlind' | 'bigBlind'>;

export interface GameRegisterPayload {
  gametype: string;
  country: string;
  seats: number[];
  games: number[];
  structures: number[];
  currencies: string[];
  stakes: {
    lo: number;
    hi: number;
  };
  minimumBuyIn: number;
  maximumBuyIn: number;
}

export type SupportedCurrency =
  | Currency.CanadianDollar
  | Currency.Euro
  | Currency.BritishPound
  | Currency.PlayMoney
  | Currency.USDollar;

export interface Integer64 {
  lo: number;
  hi?: number;
}

export type MultiplierConfig = MultiplierBlock['multiplier'];

export type StakeConfig = StakeBlock['stake'];

export type AdditionalParam =
  AdditionalConfigBlock['additional_config']['additional_params'][number];

export interface FilteredConfig {
  stakes?: StakeConfig['stakes'][];
  bbMultiplierZoom?: { min: number; max: number };
  bbMultiplierRegular?: { min: number; max: number };
}

export type ModularBlock = AdditionalConfigBlock[][number];

export enum Platform {
  Web = 'Web',
  Embedded = 'Embedded'
}
